import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import Routes from './Routes/Routes';
import store from './store/';
import reportWebVitals from './reportWebVitals';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <>
        <Provider store={store}>
            <Routes />
        </Provider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
